import { Helmet } from 'react-helmet-async'
import { Box, Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Home, Refresh } from '@mui/icons-material'

export default function ServerErrorPage() {
  const navigate = useNavigate()

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <>
      <Helmet>
        <title>500 - Server Error | Taylin Helpdesk</title>
        <meta name="description" content="Something went wrong on our end. We're working to fix it." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #fc4a1a 0%, #f7b733 100%)',
          color: 'white'
        }}
      >
        <Container maxWidth="md">
          <Box textAlign="center">
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '6rem', md: '10rem' },
                fontWeight: 900,
                mb: 2,
                textShadow: '0 4px 20px rgba(0,0,0,0.3)'
              }}
            >
              500
            </Typography>
            <Typography
              variant="h4"
              sx={{
                mb: 2,
                fontWeight: 600
              }}
            >
              Server Error
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                opacity: 0.9,
                fontSize: '1.1rem'
              }}
            >
              Something went wrong on our end. We're working to fix it. Please try again in a moment.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}
            >
              <Button
                variant="contained"
                size="large"
                startIcon={<Home />}
                onClick={() => navigate('/')}
                sx={{
                  bgcolor: 'white',
                  color: '#fc4a1a',
                  '&:hover': {
                    bgcolor: 'rgba(255,255,255,0.9)'
                  },
                  py: 1.5,
                  px: 4
                }}
              >
                Go Home
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<Refresh />}
                onClick={handleRefresh}
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  '&:hover': {
                    borderColor: 'white',
                    bgcolor: 'rgba(255,255,255,0.1)'
                  },
                  py: 1.5,
                  px: 4
                }}
              >
                Try Again
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  )
}
